<template>
  <div class="HomePage">
    <div style="width: 100%; height: 100%">
      <div class="pageTitle">
        <div class="titleBg">
          <div class="titleBox">
            <div class="boxImg"><img :src="imgLogo" /></div>
            <!-- <div class="boxStyle">
                <i class="iconfont icondidian"></i>
                <span class="titleCity">{{ weather.district }}</span>
                <span class="titleWeather">{{$t('HomPage.weather')}}</span>
                {{ weather.temperature }}
              </div> -->
          </div>
          <div class="titleStyle">{{ $t('HomPage.ForkliftIntelligentManagementPlatform') }}</div>
          <div class="titleBox">
            <div class="boxRight">
              <div class="rightInfo">
                <!-- <span class="infoTxt">{{ date }}</span>
                  <span class="infoTxt">{{ week }}</span>
                  <span class="infoTxt">{{ time }}</span> -->
                <span class="titleBtn" @click="toggleFullScreen">
                  <i :class="this.iFullScreen
                    ? 'iconfont iconchuangkouhuanyuan'
                    : 'iconfont iconfangda'
                    " :title="$t('HomPage.toggleFullScreen')">
                  </i>{{ this.iFullScreen ? this.$t('HomPage.exitFullScreen') : this.$t('HomPage.fullScreen') }}
                </span>
                <span class="titleBtn" @click="btnEnter"><i class="iconfont iconicon-houtaiguanli"></i>{{
                  $t('HomPage.backManagement') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-row style="height: 93%;padding: 10px;box-sizing: border-box;">
        <el-col :span="6" class="conLeft">
          <div class="leftUp">
            <Chart :options="amountOption" style="width: 100%; height: 100%" />
            <!-- <linegraph :id="'carBargraph'" :data="amountOption" style="width: 100%; height: 100%"></linegraph> -->
          </div>
          <div class="leftDown">
            <div class="downBox">
              <div class="boxTitle">
                <div class="titleName">维修保养</div>
                <div class="titleTxt">
                  <img src="../../../assets/images/newMoney.png" />
                  <span style="display: inline-block">
                    <p>{{ totalExpenditure }}</p>
                    <div>单台月均（元）</div>
                  </span>
                </div>
              </div>
              <div class="boxBar">
                <Chart :options="numberOption" style="width: 100%; height: 100%" />
              </div>
              <div class="boxBar">
                <Chart :options="costOption" style="width: 100%; height: 100%" />
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" class="conCenter">
          <div class="centerUp">
            <el-row :gutter="20">
              <el-col :span="8" style="text-align: center" v-for="(title, index) in titles" :key="index">
                <div class="upTitle">{{ title.title }}</div>
                <div class="upNumber">
                  <span>{{ title.number }}</span>
                </div>
                <div class="upAdd">
                  {{ title.new }}
                  <span>{{ title.add }}</span>
                  {{ title.unit }}
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="centerMap">
            <Chart id="worldMap" :options="worldMapOption" style="width: 100%; height: 100%" />
            <!-- <Chart v-else id="map" :options="mapOption" style="width: 100%; height: 85%" /> -->
            <!-- <div @click="showBtn" class="downIcon">
              <el-icon v-if="!isShow">
                <CaretTop />
              </el-icon>
              <el-icon v-if="isShow">
                <CaretBottom />
              </el-icon>
              <div class="centerDown" v-show="isShow">
                <div v-for="(n, index) in List" :key="index">
                  <div class="downNumber">
                    <span>{{ n.number }}</span>
                    {{ n.unit }}
                  </div>
                  <div class="downTitle">{{ n.text }}</div>
                </div>
              </div>
            </div> -->
          </div>
        </el-col>
        <el-col :span="6" class="conRight">
          <div class="rightUp">
            <div class="upTitle">风险警示</div>
            <div style="display: flex;height: 90%;">
              <div style="width: 50%; height: 100%">
                <Chart :options="simOption" style="width: 100%; height: 80%" />
                <div style="text-align: center;color: #fff;font-size: 13px;font-weight: 500;">SIM卡拔出0</div>
              </div>
              
              <div style="width: 50%; height: 100%" @click="leaveClick">
                <Chart id="leaveId" :options="leaveOption" style="width: 100%; height: 80%" />
                <div style="text-align: center;color: #fff;font-size: 13px;font-weight: 500;">离开风险区域{{ leave }}</div>
              </div>
            </div>
          </div>
          <div class="rightCenter">
            <Chart id="violationId" :options="violationOption" style="width: 100%; height: 100%" />
          </div>
          <div class="rightDown">
            <Chart id="faultId" :options="faultOption" style="width: 100%; height: 100%" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import HomeZeki from "./HomeZeki.js";
export default HomeZeki;
</script>

<style lang="less" scoped>
@import url("./HomeZeki.less");
</style>